"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Helper_1 = require("../../Helper");
const Message_1 = __importDefault(require("./Message"));
const defaultOptions = {
    position: "neos-notification-top",
    timeout: 5000,
    type: "info",
};
class Toast {
    constructor() {
        this.container = document.getElementById("neos-notification-container");
        this.initialize();
    }
    initialize() {
        if ((0, Helper_1.isNil)(this.container)) {
            const applicationContainer = document.getElementById("neos-application");
            if (!(0, Helper_1.isNil)(applicationContainer)) {
                this.container = document.createElement("div");
                this.container.id = "neos-notification-container";
                applicationContainer.appendChild(this.container);
            }
        }
    }
    /**
     * Internal function to creates a Message and adds them to the notification container
     *
     * @param {MessageOptions} options
     * @returns {void}
     */
    create(options) {
        const toastOptions = Object.assign(Object.assign({}, defaultOptions), options);
        if (!(0, Helper_1.isNil)(toastOptions.position)) {
            this.container.classList.add(toastOptions.position);
        }
        new Message_1.default(toastOptions, this.container);
    }
    /**
     * Creates a new notification as Message
     *
     * @param {MessageOptions} options
     * @returns {void}
     */
    static create(options) {
        // @ts-ignore
        if ((0, Helper_1.isNil)(this._container)) {
            const toast = new Toast();
            toast.create(options);
        }
        else {
            // @ts-ignore
            this._create(options);
        }
    }
    /**
     * Removes all messages within the notification container
     *
     * @returns {void}
     */
    static removeAll() {
        // @ts-ignore
        const messages = Array.from(this._container.childNodes);
        messages.forEach((messageElement) => {
            if (!(0, Helper_1.isNil)(messageElement)) {
                messageElement.classList.add("fade-out");
                setTimeout(() => {
                    messageElement.remove();
                }, 250);
            }
        });
    }
}
exports.default = Toast;
